const initState = {
  warningTypes: [],
};

const state = JSON.parse(JSON.stringify(initState));

const mutations = {};

const actions = {};

export default {
  name: 'fault',
  namespaced: true,
  state,
  mutations,
  actions,
};
